import * as _hm from './_hm';
import * as _ht from './_ht';

export const f = (
  date: Date | _ht.s,
  stl?: _ht.s,
  bPdg?: _ht.b,
): string => {
  const _dtm = new Date(date);
  const _YYYY = _dtm.getFullYear();
  let _MM = String(_dtm.getMonth() + 1); //１を足すこと
  if (Number(_MM) < 10) {
    _MM = bPdg != false ? ('0' + _MM) : (' ' + _MM);
  }
  let _DD = String(_dtm.getDate());
  if (Number(_DD) < 10) {
    _DD = bPdg != false ? ('0' + _DD) : (' ' + _DD);
  }
  let _hh = String(_dtm.getHours());
  if (Number(_hh) < 10) {
    _hh = '0' + _hh;
  }
  let _mm = String(_dtm.getMinutes());
  if (Number(_mm) < 10) {
    _mm = '0' + _mm;
  }
  let _ss = String(_dtm.getSeconds());
  if (Number(_ss) < 10) {
    _ss = '0' + _ss;
  }
  switch (stl) {
    case '年月日（曜日）':
      return `${_YYYY}年${_MM}月${_DD}日（${cvtDow(date)}曜日）`;
    case '年月日（曜）':
      return `${_YYYY}年${_MM}月${_DD}日（${cvtDow(date)}）`;
    case '年月日':
      return `${_YYYY}年${_MM}月${_DD}日`;
    case '年月':
      return `${_YYYY}年${_MM}月`;
    case '月':
      return `${_MM}月`;
    case '日（曜）':
      return `${_DD}日（${cvtDow(date)}）`;
    case '時分':
      return `${_hh}時${_mm}分`;
    case '元号':
      return `令和${_YYYY-2018}年`;
    case 'YYYYMMDD':
      return `${_YYYY}${_MM}${_DD}`;
    case 'YYYYMM':
      return `${_YYYY}${_MM}`;
    case 'YYYY-MM':
      return `${_YYYY}-${_MM}`;
    case 'YYYY-MM-DD':
      return `${_YYYY}-${_MM}-${_DD}`;
    case 'YYYY-MM-DD hh:mm:ss':
      return `${_YYYY}-${_MM}-${_DD} ${_hh}:${_mm}:${_ss}`;
    case 'YYYYMMDDhhmmss':
      return `${_YYYY}${_MM}${_DD}${_hh}${_mm}${_ss}`;
    default:
      //hf.l(`hfDTM 37: incorrect stl ${stl}`);
      return `${_YYYY}-${_MM}-${_DD}`;
  }
};

export const addMnt = (
  dtm: _ht.s, 
  mnt: _ht.n,
): _ht.s => {
  const _dtm = new Date();
  _dtm.setTime(Date.parse(`${String(dtm).substring(0,10)}T${String(dtm).substring(11)}`) + mnt * 60000)
  return f(_dtm);
};

export const addHour = (
  dtm: _ht.s, 
  pnHour: _ht.n
): _ht.s => {
  const _dtm = new Date();
  _dtm.setTime(Date.parse(`${String(dtm).substring(0,10)}T${String(dtm).substring(11)}`) + pnHour * 3600000)
  return f(_dtm);
};

export const addDay = (
  dtm: _ht.s, 
  pnVle: _ht.n
): _ht.s => {
  const _dtm = new Date(dtm);
  _dtm.setDate(_dtm.getDate() + pnVle);
  return f(_dtm);
};

export const addMth = (
  dtm: _ht.s, 
  pnVle: _ht.n
): _ht.s => {
  const _dtm = new Date(dtm);
  _dtm.setMonth(_dtm.getMonth() + pnVle);
  return f(_dtm);
};

export const addYear = (
  dtm: _ht.s,
  pnVle: _ht.n,
): _ht.s => {
  const _dtm = new Date(dtm);
  _dtm.setMonth(_dtm.getMonth() + pnVle * 12);
  return f(_dtm);
};

export const cvt24 = (
  dtm: _ht.s,
) => {
  const _date = dtm.substring(0,10);
  const _time = dtm.substring(11,19);
  if (!_time) {
    return _date;
  }
  else {
    let _dtm = `${_date} 23:${_time.substring(3,8)}`;
    const _nHH = Number(_time.substring(0,2));
    _dtm = addMnt(_dtm, (_nHH - 23) * 60);
    return _dtm;
  }
};

export const cvtCdrDates = (
  dtm: _ht.s,
) => {
  const _dtm = new Date(dtm);
  const _fstDate = cvtFdm(_dtm);
  const _lastDate = cvtLdm(_dtm);
  const _nLastDay = cvtDay(_lastDate);
  return Array.from(_hm.getRng(
    _nLastDay + (6 - cvtDowNbr(_lastDate)),
    1 - cvtDowNbr(_fstDate)
  )).map(_n_day => addDay(_fstDate, _n_day - 1));
};

export const cvtCeilHour = (
    dtm: _ht.s, 
    pnHour: _ht.n
) => {
  const _nHour = _hm.cvtCeil(_hm.n(String(dtm).substring(11,13)) / pnHour) * pnHour;
  const _org = `${String(dtm).substring(0,10)}T00:00:00`;
  return addHour(_org, _nHour);
};

export const cvtFlrHour = (
    dtm: _ht.s, 
    pnHour: _ht.n
) => {
  const _nHour = _hm.cvtFlr(_hm.n(String(dtm).substring(11,13)) / pnHour) * pnHour;
  const _org = `${String(dtm).substring(0,10)}T00:00:00`;
  return addHour(_org, _nHour);
};

export const cvtCeilMnt = (
    dtm: _ht.s, 
    mnt: _ht.n
) => {
  const _mnt = _hm.cvtCeil(_hm.n(String(dtm).substring(14,16)) / mnt) * mnt;
  const _org = `${String(dtm).substring(0,10)}T${String(dtm).substring(11,13)}:00:00`;
  return addMnt(_org, _mnt);
};

export const cvtFlrMnt = (
    dtm: _ht.s, 
    mnt: _ht.n
) => {
  const _mnt = _hm.cvtFlr(_hm.n(String(dtm).substring(14,16)) / mnt) * mnt;
  const _org = `${String(dtm).substring(0,10)}T${String(dtm).substring(11,13)}:00:00`;
  return addMnt(_org, _mnt);
};

export const cvtDates = (
  dateStt: _ht.s,
  dateEnd: _ht.s
) => {
  const _cnt = getDrcDay(dateStt, dateEnd) + 1;
  return _hm.getRng(_cnt).map( _dff => addDay(dateStt, _dff - 1));
};

export const cvtDay = (
  dtm: _ht.s,
): _ht.n => {
  const _dtm = new Date(dtm);
  return Number(f(_dtm).substring(8, 10));
};

export const cvtDow = ( // day of the week
  dtm: Date | _ht.s,
) => {
  return ["日", "月", "火", "水", "木", "金", "土"][cvtDowNbr(dtm)];
}; 

export const cvtDowNbr = ( // day of the week number
  dtm: Date | _ht.s,
) => {
  const _dtm = new Date(dtm);
  return _dtm.getDay();
}; 

export const cvtFdm = (
  dtm: Date | _ht.s
) => {
  let _dtm = new Date(dtm);
  _dtm = new Date(_dtm.getFullYear(), _dtm.getMonth(), 1); // 今月末
  return f(_dtm);
};

export const cvtLdm = (
  dtm: Date | _ht.s
) => {
  let _dtm = new Date(dtm);
  _dtm = new Date(_dtm.getFullYear(), _dtm.getMonth() + 1, 0); // 今月末
  return f(_dtm);
};

export const cvtMth = (
  dtm: Date | _ht.s
) => {
  const _dtm = new Date(dtm);
  return Number(f(_dtm).substring(5, 7));
};

export const cvtMthDates = (
  dtm: Date | _ht.s,
  dayStt?: _ht.n,
  dayEnd?: _ht.n,
) => {
  const _dtm = new Date(dtm);
  const _fdm = dayStt ? addDay(cvtFdm(_dtm), dayStt - 1) : cvtFdm(_dtm);
  const _ldm = dayEnd ? addDay(cvtFdm(_dtm), dayEnd - 1) : cvtLdm(_dtm);
  const _nDayCnt = cvtDay(_ldm) - cvtDay(_fdm) + 1;
  return _hm.getRng(_nDayCnt).map((_nDay: _ht.n) => addDay(_fdm, _nDay-1))
};

export const getDrcDay = ( // difference 日単位
  dtm1: _ht.s, 
  dtm2: _ht.s
) => {
  const _dtm1 = new Date(String(cvt24(dtm1)).replace(' ', 'T'));
  const _dtm2 = new Date(String(cvt24(dtm2)).replace(' ', 'T'));
  return (_dtm2.getTime() - _dtm1.getTime()) / 86400000 ?? 0;
};

export const getDrcHour = ( // difference 時間単位
  dtm1: _ht.s, 
  dtm2: _ht.s
) => {
  const _dtm1 = new Date(String(cvt24(dtm1)).replace(' ', 'T'));
  const _dtm2 = new Date(String(cvt24(dtm2)).replace(' ', 'T'));
  return (_dtm2.getTime() - _dtm1.getTime()) / 3600000 ?? 0;
};

export const getDrcMnt = ( // difference 分単位
  dtm1: _ht.s, 
  dtm2?: _ht.s
) => {
  const _dtm1 = new Date(dtm1);
  const _dtm2 = new Date(dtm2 ?? getNow());
  return (_dtm2.getTime() - _dtm1.getTime()) / 60000 ?? 0; // ミリ秒を変換、端数切り捨て
};

export const getDrcScd = ( // difference 秒単位
  dtm1: _ht.s, 
  dtm2: _ht.s
) => {
  const _dtm1 = new Date(String(cvt24(dtm1)).replace(' ', 'T'));
  const _dtm2 = new Date(String(cvt24(dtm2)).replace(' ', 'T'));
  return (_dtm2.getTime() - _dtm1.getTime()) / 1000 ?? 0; // ミリ秒を変換、端数切り捨て
};

export const getNthDowDate = ( // date が属する月の、第 week 回目の dow 曜日
  date: _ht.s,
  week: _ht.n,
  dow: _ht.n
) => {
  const _fdm = cvtFdm(date);
  const _fdmDow = cvtDowNbr(_fdm); 
  let _drc = dow - _fdmDow; // difference
  if ( dow < _fdmDow) _drc = 7 - ( _fdmDow - dow );
  const _fstDowDate = addDay(_fdm, _drc);
  const _tgtDowDate = addDay(_fstDowDate, 7 * ( week - 1 ))
  return _tgtDowDate;
}
  
export const getNthDowDates = ( // sttDate から endDate までの 第 week 回目の dow 曜日の一覧
  dateStt: _ht.s,
  dateEnd: _ht.s,
  week: _ht.n,
  dow: _ht.n,
) => {
  const _dates = [];
  if ( _hm.f(dateStt) && _hm.f(dateEnd) && week > 0 && dow >= 0) {
    let _date = cvtFdm(dateStt);
    while ( _date <= dateEnd ) {
      const _dateTgt = getNthDowDate(_date, week, dow);
      if ( _dateTgt >= dateStt && _dateTgt <= dateEnd ) {
        _dates.push(_dateTgt);
      }
      _date = addMth(_date, 1);
    }
  }
  return _dates;
}

export const getNow = (): _ht.s => {
  const _dtm = new Date();
  return f(_dtm, 'YYYY-MM-DD hh:mm:ss');
};

export const getTdy = (): _ht.s => {
  const _dtm = new Date();
  return f(_dtm);
};

export const grtDates = (
  dateStt: _ht.s,
  dateEnd: _ht.s,
) => {
  const _nDays = getDrcDay(dateStt, dateEnd) + 1;
  const _ls = _hm.getRng(_nDays).map( (_nCnt: _ht.n) => addDay(dateStt, _nCnt - 1));
  return _ls;
};
export const getDates = grtDates; // 廃止予定

export const grtYearMth = (
  year: _ht.s | _ht.n,
  mth: _ht.s | _ht.n,
) => {
  return `${year}-${_hm.pdg(mth, 2, '0')}`
}

/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
